// One Hebrew relative-time phrasing for the whole app.
//
// This used to exist four times — timeAgoHe/timeAgoMs in HomeTab, and a
// relTime in each of GeoIntelTab, StockPage and NewsTab — same wording, three
// different input types, and two of them phrased the edges differently.
//
// The canonical scale takes the best phrasing of the four rather than their
// average: NewsTab's "הרגע" and "אתמול" win. "הרגע" describes a finding — this
// arrived a moment ago — where "עכשיו" implies an ongoing state; and "אתמול"
// is simply Hebrew, where "לפני 1 ימים" is a template leaking through.
//
// Bands: under a minute · minutes · hours · yesterday · days. Nothing coarser,
// because a scan timestamp older than that is a finding the caller should
// surface, not a phrase to round away.

// Canonical implementation — milliseconds since epoch.
export function timeAgoMs(ms) {
  // 0 or missing is "no time", not 1 January 1970 ("לפני 20722 ימים").
  if (!Number.isFinite(ms) || ms <= 0) return "";
  const min = Math.floor(Math.max(0, Date.now() - ms) / 60000);
  if (min < 1)  return "הרגע";
  if (min < 60) return `לפני ${min} דק׳`;
  const h = Math.floor(min / 60);
  if (h < 24)   return `לפני ${h} שע׳`;
  const d = Math.floor(h / 24);
  return d === 1 ? "אתמול" : `לפני ${d} ימים`;
}

// Unix seconds — what Finnhub returns on article timestamps.
export function timeAgoSec(sec) {
  return Number.isFinite(sec) ? timeAgoMs(sec * 1000) : "";
}

// ISO string — what Postgres returns for timestamptz columns. A missing or
// unparsable value yields "" so the caller renders nothing rather than a guess.
export function timeAgoIso(iso) {
  if (!iso) return "";
  const t = Date.parse(iso);
  return Number.isFinite(t) ? timeAgoMs(t) : "";
}
